<template>
  <div class="section">
    <div class="section-title">{{ title }}</div>
    <div class="section-body">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String
    }
  }
}
</script>
